<template>
    <div class="nom">
        <div class="head">
            <i class="back"
               @click="back()"></i>
            <p class="title">{{name}}</p>
        </div>

        <ul class="list"
            v-if="loading">
            <template v-for="l in list">
                <template v-if="(l instanceof Array)">
                    <li @click="toRepeat(p,1)"
                        v-for="p in l">
                        <div>{{p.title}}</div>
                        <em>{{p.score}}</em><i></i>
                    </li>
                </template>
                <template v-else>
                    <li @click="toRepeat(l,0)">
                        <div>单词跟读</div>
                        <em>{{l.score}}</em><i></i>
                    </li>
                </template>
            </template>
        </ul>
        <loadingS v-else></loadingS>
    </div>
</template>

<script type="text/ecmascript-6">
import loadingS from 'COMPONENTS/base/tealoading.vue';

export default {
    data () {
        return {
            name: this.$route.query.name,//学生名
            sid: this.$route.params.sid,//学生名
            message_id: this.$route.params.message_id,//学生名
            task_type: this.$route.params.task_type,//学生名
            user_id: this.$route.params.user_id,//学生名
            list: [],
            loading: false,
        }
    },
    components: {
        loadingS
    },
    methods: {
        toRepeat (l, type) {
            localStorage.setItem('nom_check', JSON.stringify(l));
            this.$router.push('/english/nom_repeat/' + this.sid + '/' + this.message_id + '/' + this.task_type + '/' + this.user_id + '?type=' + type)
        },
    },
    created () {
        this.$http.post(API_URL_TASK_API + '/english/check/personal', {
            user_id: this.user_id,
            message_id: this.message_id,
            sid: this.sid,
            task_type: this.task_type
        }).then(res => {
            res = res.data;
            if (res.response === 'ok') {
                this.list = res.data;
                this.loading = true;
            }
        })
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.nom {
    min-height: 100vh;
    background: #f5f9ff;
    overflow-x: hidden;
    .head {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10;
        width: 100vw;
        height: 96px / $ppr;
        background: #5e89ef;
        .back {
            position: absolute;
            top: 30px / $ppr;
            left: 24px / $ppr;
            width: 18px / $ppr;
            height: 36px / $ppr;
            background: url(./img/choose_back.png) no-repeat;
            background-size: 100% 100%;
        }
        .title {
            width: 100%;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            font-size: 34px / $ppr;
            color: #fff;
            text-align: center;
        }
    }
    .list {
        padding-top: 96px / $ppr;
        padding-bottom: 24px / $ppr;
        li {
            position: relative;
            padding: 0 24px / $ppr;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            background: #fff;
            border-top: 1px / $ppr solid #e8e8e8;
            &:first-child {
                border-top: none;
            }
            div {
                width: 512px / $ppr;
                font-size: 30px / $ppr;
                color: #333;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            em {
                display: block;
                position: absolute;
                top: 50%;
                right: 64px / $ppr;
                margin-top: -30px / $ppr;
                width: 60px / $ppr;
                height: 60px / $ppr;
                line-height: 60px / $ppr;
                text-align: center;
                font-size: 36px / $ppr;
                color: #5e89ef;
                background: #dbecfe;
                border: 1px / $ppr solid #5e89ef;
                border-radius: 60px / $ppr;
            }
            i {
                position: absolute;
                top: 50%;
                right: 24px / $ppr;
                margin-top: -14.5px / $ppr;
                width: 16px / $ppr;
                height: 29px / $ppr;
                background: url("./img/icon-right.png") no-repeat;
                background-size: 100% 100%;
            }
        }
    }
}
</style>
